import React from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';

const ParameterForm = ({ algorithm, onLogUpdate, onVideoUpdate }) => {
  const { register, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    try {
      onLogUpdate(`🚀 Submitting training for ${algorithm}...`);
      const response = await axios.post('/api/train/', {
        algorithm,
        ...data,
      });

      onLogUpdate(response.data.logs || '✅ Training started...');
      onVideoUpdate(response.data.resultVideo || null);
    } catch (error) {
      onLogUpdate('❌ Error submitting training job.');
      onVideoUpdate(null);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 bg-gray-50 p-6 rounded-xl border">
      <h3 className="text-lg font-semibold text-gray-800 mb-2">📋 Parameters for {algorithm}</h3>

      <div>
        <label className="block font-medium mb-1">🔢 Particle Count</label>
        <input
          type="number"
          {...register('particleCount')}
          className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          required
        />
      </div>

      <div>
        <label className="block font-medium mb-1">📏 Trajectory Length</label>
        <input
          type="number"
          {...register('trajectoryLength')}
          className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          required
        />
      </div>

      <button
        type="submit"
        className="mt-4 bg-blue-600 text-white font-semibold px-6 py-2 rounded hover:bg-blue-700 transition"
      >
        🚀 Submit Training
      </button>
    </form>
  );
};

export default ParameterForm;
